/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";

const ButtonView = styled.div`
  display: inline-block;
  width: 120px;
  margin: 6px;
  padding: 9px 0;
  font-weight: 300;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 1;
  text-align: center;
  text-decoration: none;
  color: ${({ theme, isSubmit }) => isSubmit ? theme.alternativeForeground : theme.foreground};
  background-color: ${props =>
    props.isSubmit ? props.theme.upper : "#bfbfbf"};
  border: 0px;
  border-radius: 4px;
  user-select: none;
  cursor: pointer;

  :focus {
    outline: none;
  }

  :hover {
    background-color: ${props => props.theme.accent};
    color: ${props => props.theme.mainDark};
  }

  @media(max-width: 959px) {
    width: auto;
    padding: 9px 18px;
  }

  ${props => props.disabled && css`
    background-color: #97959a;

    :hover {
      cursor: default;
      background-color: #97959a;
      color: ${({ theme }) => theme.foreground};
    }
  `}
`;

function Button(props: Object) {
  return <ButtonView {...props} />;
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Popup/Button.js